const labels = window.compareLabels;

export const sections = [
    {
        id: "price",
        label: labels.price,
        type: "default",
    },
    {
        id: "ink",
        label: labels.ink,
        type: "expandset",
        subsections: [
            {
                id: "ink-type",
                label: labels.inkType,
            },
        ],
    },
    {
        id: "max-area-media",
        label: labels.maxAreaMedia,
        type: "expandset",
        subsections: [
            {
                id: "max-media-dia",
                label: labels.maxPrintArea,
            },
            {
                id: "max-media-width",
                label: labels.maxMediaWidth,
            },
            {
                id: "max-media-thickness",
                label: labels.maxMediaThickness,
            },
            {
                id: "max-media-weight1",
                label: labels.maxMediaWeight,
            },
        ],
    },
    {
        id: "printing-specs",
        label: labels.printingSpecs,
        type: "expandset",
        subsections: [
            {
                id: "heads",
                label: labels.printhead,
            },
            {
                id: "print-resolution",
                label: labels.printResolution,
            },
            {
                id: "max-printing-speed",
                label: labels.maxPrintSpeed,
            },
            // {
            //     id: "print-speed-4-color",
            //     label: "Print Speed (4 color mode)",
            // },
        ],
    },
    {
        id: "installation-connectivity",
        label: labels.installationConnectivity,
        type: "expandset",
        subsections: [
            {
                id: "connection-interface",
                label: labels.interface,
            },
            {
                id: "dimensions",
                label: labels.dimensions,
            },
            {
                id: "weight",
                label: labels.weight,
            },
            {
                id: "machine-certifications",
                label: labels.certifications,
            },
        ],
    },
    {
        id: "upgrades",
        label: labels.upgrades,
        type: "expandset",
        subsections: [
            {
                id: "upgrades-1",
                label: labels.upgrades1,
            },
            {
                id: "upgrades-2",
                label: labels.upgrades2,
            },
        ],
    },
    {
        id: "applications",
        label: labels.applications,
        type: "default",
    },
];
